
    import "src/app/AppSeller/Orders/ManualOrder/Components/OrderDetails/index.module.scss?farm_css_modules";
    
    export default {}
    